_collow.components.CompanyFinance = class CompanyFinance extends (
    _collow.components.Base
) {
    root;
    elements;
    params;

    constructor(root, elements, params) {
        super();

        this.root = root;
        this.elements = elements;
        this.params = params;

        this.getSubscriptionInfo();
        this.getCompanyTokens();

        this.listen(elements.cancelSubscription, "click", () => {
            this.handleCancelSubscriptionClick();
        });
    }

    getSubscriptionInfo = async () => {
        const info = await fetching(
            this.params.path + "/payments/subscription",
            "get"
            // TODO error handling
        ).catch((err) => console.log(err));

        this.elements.subscriptionTier.innerHTML += ` ${info.subscription_tier}`;
        this.elements.memberSince.innerHTML += ` ${info.subscription_start}`;
        this.elements.nextPayment.innerHTML += ` ${info.next_payment}`;
        this.elements.nextTokenRefill.innerHTML += ` ${info.next_tokens}`;
    };

    getCompanyTokens = async () => {
        const tokens = await fetching(
            this.params.path + "/payments/available_tokens",
            "get"
            // TODO error handling
        ).catch((err) => console.log(err));

        this.elements.tokens.innerHTML += ` ${tokens.subscription_tokens} / ${tokens.additional_tokens}`;
    };

    handleCancelSubscriptionClick = async () => {
        //TODO 'are you sure?' confirmation message -> still needs to be designed
        const response = await fetching(
            this.params.path + "/payments/subscribe",
            "delete"
            // TODO error handling
        ).catch((err) => console.log(err));

        //TODO deleted successfully message??
    };
}; 